// @flow

import {
  MESSAGE_TYPE_ADD_TO_CART,
  MESSAGE_TYPE_LOADED,
  MESSAGE_TYPE_PRODUCTS,
  MESSAGE_TYPE_PRODUCT_BUTTON,
  MESSAGE_TYPE_RESTART,
  MESSAGE_TYPE_STARTED,
  type EventPayload
} from '../../../common/iframeMessageTypes'

import {
  EVENT_SENDERS,
  type Wizard$StartedEventPayload,
  type Wizard$LoadedEventPayload,
  type Wizard$CompletedEventPayload,
  type Wizard$RecommendedProductClickedEventPayload,
  type Wizard$AddedToCartEventPayload,
  type Wizard$RoutineAddedToCartEventPayload,
  WIZARD_EVENTS
} from '../types'
import { forwardEventToWebAnalytics } from '../webAnalytics'

// @deprecated; this is an adapter to the old event tracking API, see README of event tracking
function forwardWizardEventToWebAnalytics (event: EventPayload): void {
  forwardEventToWebAnalytics({
    eventSender: EVENT_SENDERS.WIZARD,
    ...event
  })
}

function forwardLoadedEventToWebAnalytics (_eventPayload: Wizard$LoadedEventPayload): void {
  forwardWizardEventToWebAnalytics({ event: MESSAGE_TYPE_LOADED })
}

function forwardStartedEventToWebAnalytics (_eventPayload: Wizard$StartedEventPayload): void {
  forwardWizardEventToWebAnalytics({ event: MESSAGE_TYPE_STARTED })
}

function forwardCompletedEventToWebAnalytics (_eventPayload: Wizard$CompletedEventPayload): void {
  forwardWizardEventToWebAnalytics({ event: MESSAGE_TYPE_PRODUCTS })
}

function forwardRecommendedProductClickedEventToWebAnalytics (_eventPayload: Wizard$RecommendedProductClickedEventPayload): void {
  forwardWizardEventToWebAnalytics({ event: MESSAGE_TYPE_PRODUCT_BUTTON })
}

function forwardAddedToCartEventToWebAnalytics (eventPayload: Wizard$AddedToCartEventPayload): void {
  forwardWizardEventToWebAnalytics({
    event: MESSAGE_TYPE_ADD_TO_CART,
    product: eventPayload.product,
    productId: eventPayload.productId
  })
}

function forwardRestartedEventToWebAnalytics (): void {
  forwardWizardEventToWebAnalytics({ event: MESSAGE_TYPE_RESTART })
}

function forwardRoutineAddedToCartEventToWebAnalytics (eventPayload: Wizard$RoutineAddedToCartEventPayload): void {
  forwardWizardEventToWebAnalytics({
    event: MESSAGE_TYPE_ADD_TO_CART,
    products: eventPayload.products,
    productIds: eventPayload.productIds
  })
}

const eventsWrapper = {
  loaded: ({ detail }) => forwardLoadedEventToWebAnalytics(detail),
  started: ({ detail }) => forwardStartedEventToWebAnalytics(detail),
  completed: ({ detail }) => forwardCompletedEventToWebAnalytics(detail),
  recommendedProductClicked: ({ detail }) => forwardRecommendedProductClickedEventToWebAnalytics(detail),
  addedToCart: ({ detail }) => forwardAddedToCartEventToWebAnalytics(detail),
  restarted: () => forwardRestartedEventToWebAnalytics(),
  routineAddedToCart: ({ detail }) => forwardRoutineAddedToCartEventToWebAnalytics(detail)
}

export function registerWebAnalyticsListeners (): void {
  if (window.trboAdvisorRegisteredWebAnalyticsListeners) return

  window.trboAdvisorRegisteredWebAnalyticsListeners = true
  window.addEventListener(WIZARD_EVENTS.Loaded, eventsWrapper.loaded)
  window.addEventListener(WIZARD_EVENTS.Started, eventsWrapper.started)
  window.addEventListener(WIZARD_EVENTS.Completed, eventsWrapper.completed)
  window.addEventListener(WIZARD_EVENTS.RecommendedProductClicked, eventsWrapper.recommendedProductClicked)
  window.addEventListener(WIZARD_EVENTS.AddedToCartEvent, eventsWrapper.addedToCart)
  window.addEventListener(WIZARD_EVENTS.RestartedEvent, eventsWrapper.restarted)
  window.addEventListener(WIZARD_EVENTS.RoutineAddedToCartEvent, eventsWrapper.routineAddedToCart)
}
